import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  contentChild,
  input,
  model,
  TemplateRef,
} from '@angular/core';

import { ChevronIconComponent } from '@plugins/client/icons/chevron-icon/chevron-icon.component';

import { AccordionHeaderDirective } from './accordion-header.directive';

@Component({
  selector: 'plugins-accordion',
  imports: [NgTemplateOutlet, ChevronIconComponent],
  templateUrl: './accordion.component.html',
  styleUrl: './accordion.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordionComponent {
  readonly label = input.required<string>();
  readonly collapsible = input<boolean>(true);
  readonly collapsed = model<boolean>(true);

  readonly headerTemplateRef = contentChild(AccordionHeaderDirective, {
    read: TemplateRef,
  });

  onToggle(e: Event): void {
    e.preventDefault();
    e.stopPropagation();

    if (this.collapsible()) {
      this.collapsed.update((c) => !c);
    }
  }
}
